import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";

const ProcurementTemplateList = (props) => {
  const { addForm } = props;

  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const itemsPerPage = localStorage.getItem("pageSize") || 10;
  const [farmerData, setFarmerData] = useState([]);
  const [
    farmerAgronomyRecommendationData,
    setFarmerAgronomyRecommendationData,
  ] = useState([]);

  const getProcurementTemplateUrl = `/api/procurementTemplate/?orgId=${localStorage.getItem(
    "orgId"
  )}`;

  const { sendRequest: getProcurementTemplateData } = useHttp();

  const getData = () => {
    getProcurementTemplateData(
      {
        url: getProcurementTemplateUrl,
      },
      (res) => {
        if (res) {
          console.log("res.output:", res);
          setData(res);
          setAllData(res);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  // const { sendRequest: getProcurementTemplate } = useHttp();

  // const getProcurementTemplateDetail = () => {
  //   getProcurementTemplate(
  //     {
  //       url: `/api/procurementTemplate/?orgId=${localStorage.getItem("orgId")}`,
  //     },
  //     (res) => {
  //       console.log("res:", res);
  //       if (res) {
  //         setData(res);
  //         setAllData(res);
  //       }
  //     },
  //     (error) => {
  //       console.log("Error", error);
  //     }
  //   );
  // };

  // useEffect(() => {
  //   getProcurementTemplateDetail();
  // }, [getProcurementTemplate]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data
    ? data.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  // console.log("currentItems", currentItems)

  const { sendRequest: getFarmerData } = useHttp();

  const getFarmerDetail = () => {
    getFarmerData(
      {
        url: "/api/getfarmerDetail/",
      },
      (res) => {
        if (res) {
          const { output } = res;
          // console.log("farmer data",output)
          setFarmerData(output);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerDetail();
  }, [getFarmerData]);

  const { sendRequest: getFarmerAgronomyRecommendationData } = useHttp();

  const getFarmerAgronomyRecommendationDetail = () => {
    getFarmerAgronomyRecommendationData(
      {
        url: "/api/farmerAgronomyRecommendation/",
      },
      (res) => {
        if (res) {
          // console.log(res);
          setFarmerAgronomyRecommendationData(res);
        }
      }
    );
  };

  useEffect(() => {
    getFarmerAgronomyRecommendationDetail();
  }, [getFarmerAgronomyRecommendationData]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, procurementTemplateId) => {
    e.preventDefault();

    const data = {
      procurementTemplateId: procurementTemplateId,
    };
    // console.log("delete started");
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this Farmer Survey Template detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/procurementTemplate/`,
            method: "DELETE",
            body: data,
          },
          (data) => {
            if (data.success) {
              // console.log("data:", data);
              toast.success(data.success);
              getDetailView();
            }

            // if (data.error) {
            //   console.log("error:", error);
            //   toast.error(data.error);
            // }
          },
          (error) => {
            console.log("Error", error);
          }
        );
      },
      onCancel() {},
    });
  };
  const handleSearch = (e) => {
    var filtertext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.procurementTempDate.toLowerCase().includes(filtertext) ||
        item.farmerName.toLowerCase().includes(filtertext) ||
        item.farmerNo.toLowerCase().includes(filtertext)
    );

    setData(filterdata);

    setCurrentPage(1);
  };

  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");
  const [selectedProcurementTemplate, setSelectedProcurementTemplate] =
    useState(null);
  const [approvalPopupVisible, setApprovalPopupVisible] = useState(false);

  const [loading, setLoading] = useState({
    approve: false,
    disapprove: false,
    sendNextApprove: false,
  });

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        // console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);

  const [remark, setRemark] = useState("");

  const { sendRequest: updateApprovalStatus } = useHttp();

  const showApprovalPopup = (expense) => {
    // console.log(expense);
    setSelectedProcurementTemplate(expense);
    setApprovalPopupVisible(true);
  };

  const handleRemarkChange = (e) => {
    setRemark(e.target.value);
  };

  const handleApprovalSubmit = (status) => {
    const approvalStatus = status || "";
    // console.log(approvalStatus);

    setLoading((prevState) => ({ ...prevState, [status]: true }));
    let data = "";
    const getApprovalData = (approvalStatus) => {
      const baseData = {
        procurementTemplateId:
          selectedProcurementTemplate &&
          selectedProcurementTemplate.procurementTemplateId,
        approvedBy: parseInt(localStorage.getItem("empId")),
        serviceId: serviceId,
        nextlevel: 0,
        orgId: parseInt(localStorage.getItem("orgId")),
        remark: remark,
      };

      switch (approvalStatus) {
        case "approve":
          return { ...baseData, approved: 1 };
        case "disapprove":
          return { ...baseData, approved: 2 };
        case "sendNextApprove":
          return { ...baseData, approved: 0, nextlevel: 1 };
        default:
          return baseData;
      }
    };

    data = getApprovalData(approvalStatus);

    // console.log(data);

    updateApprovalStatus(
      {
        url: "/api/procurementTemplateApproval/",
        method: "PUT",
        body: data,
      },
      (data) => {
        toast.success(data);
        // getProcurementTemplateDetail();
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });

        setApprovalPopupVisible(false);
        setRemark("");
        getData();
      },
      () => {
        setLoading({
          approve: false,
          disapprove: false,
          sendNextApprove: false,
        });
      }
    );
  };

  const { sendRequest: getDetailView } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // console.log(data);
    const Id = data.procurementTemplateId;
    getDetailView(
      {
        url: `/api/procurementTemplate/?orgId=${localStorage.getItem(
          "orgId"
        )}&procurementTemplateId=${Id}`,
      },
      (res) => {
        // console.log("detail view res:", res);
        setSelectedData(res);
        // const farmerData =
      },
      (error) => {
        console.log("Error", error);
      }
    );

    setIsModalOpen(true);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 50,
    },
    content: {
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "600px",
      height: "80%",
      minHeight: "auto",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Procurement Template{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2 mx-3"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Procurement Template
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row table-responsive">
                      <table className="table table-bordered text-center ">
                        <thead>
                          <tr>
                            <th>Date </th>
                            <th>Farmer Name</th>
                            <th>Farmer No</th>
                            <th>Edit</th>
                            <th>Approval</th>
                            <th>View</th>
                            <th>Status</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.procurementTempDate} </td>
                                <td>{x.farmerName} </td>
                                <td>{x.farmerNo} </td>
                                <td>
                                  <button
                                    className="btn"
                                    disabled={x.approved === 1}
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={() => showApprovalPopup(x)}
                                    disabled={x.approved === 1}
                                  >
                                    {x.approved == 1 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "green" }}
                                      ></i>
                                    ) : x.approved == 2 ? (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "red" }}
                                      ></i>
                                    ) : (
                                      <i
                                        className="fas fa-check-circle"
                                        style={{ color: "gray" }}
                                      ></i>
                                    )}
                                  </button>
                                </td>
                                <td>
                                  <button
                                    type="button"
                                    onClick={() => openModal(x)}
                                    className="btn"
                                  >
                                    {" "}
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    disabled={x.approved === 1}
                                    onClick={(e) =>
                                      handleDelete(e, x.procurementTemplateId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data ? data.length : 0}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <AntModal
        title="Farmer Survey Template Approval"
        open={approvalPopupVisible}
        onCancel={() => setApprovalPopupVisible(false)}
        footer={null}
      >
        <label>Remarks:</label>
        <textarea
          rows={3}
          value={remark}
          className="form-control"
          onChange={handleRemarkChange}
        />
        <br />
        <div>
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("approve")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.approve ? "Approving..." : "Approve"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            onClick={() => handleApprovalSubmit("disapprove")}
            className="btn btn-sm btn-primary"
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.disapprove ? "Disapproving..." : "Disapprove"}
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => handleApprovalSubmit("sendNextApprove")}
            disabled={
              loading.approve || loading.disapprove || loading.sendNextApprove
            }
          >
            {loading.sendNextApprove ? "Sending..." : "Send Next Approve"}
          </button>
        </div>
      </AntModal>

      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Procurement Template Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Date: {selectedData.procurementTempDate}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Harvesting Date: {selectedData.dateOfHarvesting}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Quantity Delivered In Bags:{" "}
                {selectedData.quantityDeliveredInBags}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Quantity Delivered In KG: {selectedData.quantityDeliveredInKg}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Quantity Deducted For Sacks In Kg:{" "}
                {selectedData.quantityDeductedForSacksInKg}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Loan Hectare Size: {selectedData.loanHectareSize}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Loan Quantity Deducted In Kg:{" "}
                {selectedData.loanQuantityDeductedInKg}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Loan Balance In Kg: {selectedData.loanBalanceInKg}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Repaid Loan In Full:{" "}
                {selectedData.repaidLoanInFull ? "yes" : "No"}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Use FMAN Sacks: {selectedData.useFMANSacks ? "yes" : "No"}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Use FMAN Harvesting Services:{" "}
                {selectedData.useFMANHarvestingServices ? "yes" : "No"}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Harvesting Services: {selectedData.harvestingServices}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Quantity Of Grains Received For Harvesting In Kg:{" "}
                {selectedData.quantityOfGrainsReceivedForHarvestingInKg}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Hectares Harvested: {selectedData.hectaresHarvested}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Price For Excess Grain: {selectedData.priceForExcessGrain}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Bags Threshed: {selectedData.bagsThreshed}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Transaction No: {selectedData.transactionNo}
              </p>
              <p
                className="col-md-6"
                style={{ textAlign: "left", paddingLeft: "13%" }}
              >
                Bags Threshed: {selectedData.paymentMethod}
              </p>
            </div>

            <div className="row">
              <p className="col-md-6">Quality Check:</p>
              <table className="table table-bordered text-center">
                <thead>
                  <tr className="tableheaderrowview">
                    <th>Sr.No</th>
                    <th>Qc Detail</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Grain With A Moisture Content Above</td>
                    <td>{selectedData.grainWithAMoistureContentAbove}</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Presence Of Insect</td>
                    <td>{selectedData.presenceOfInsect}</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Screenings</td>
                    <td>{selectedData.screenings}</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Foreign Wheat Grains Present</td>
                    <td>{selectedData.foreignWheatGrainsPresent}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ProcurementTemplateList;
